import { api } from "jiffy-api";
import { redirectTo } from "common/utils/browser";
import { isFileTypeSupported } from "common/file-type-helper";

export default class DtfFileProcessor {
  constructor($container, uiInstance, uploadManagerInstance) {
    this.$container = $container;
    this.tileId = $container.dataset.tileId;
    this.catalogNumber = $container.dataset.catalogNumber || "DTF001";
    this.uiInstance = uiInstance;
    this.uploadManager = uploadManagerInstance;
    this.uploadedFile = null;
  }

  handleFileSelection(file) {
    if (this.uploadManager.isUploadActive(this.tileId)) {
      return false;
    }

    const { valid, message } = isFileTypeSupported(file, false);

    if (!valid) {
      this.uiInstance.setErrorMessage(message);
      return false;
    }

    this.uploadedFile = file;
    return true;
  }

  #createFormData() {
    const formData = new FormData();
    formData.append("generate_link", true);
    formData.append("file", this.uploadedFile);
    formData.append("catalog_number", this.catalogNumber);
    formData.append("is_made", false);
    formData.append("is_made_flash", false);
    return formData;
  }

  #processError(e) {
    const errorResponse = e.response?.data;
    const errorMessage = errorResponse?.error || e.message;
    let uploadError = errorMessage;
    if (errorMessage === "Network Error") {
      uploadError = this.uiInstance.percentage === 100 ? "Processing error" : "Upload error";
    }

    this.uiInstance.hideProgress();
    this.uiInstance.setErrorMessage(uploadError);
  }

  async uploadArtwork() {
    if (!this.uploadedFile) return;

    this.uploadManager.setActiveUpload(this.tileId);
    this.uiInstance.showProgress(this.uploadedFile.name);
    this.uiInstance.updateProgress(0, "Uploading...");

    try {
      const response = await api.dtf.uploadArtwork(this.#createFormData(), {
        raw: true,
        headers: { "Content-Type": undefined },
        useAxiosForRequest: true,
        onUploadProgress: ({ progress }) => this.uiInstance.updateProgress(progress * 100)
      });

      this.uiInstance.updateProgress(this.uiInstance.percentage, "Redirecting...");
      setTimeout(() => redirectTo(response.redirect_url), 500);
    } catch (e) {
      this.#processError(e);
      this.uploadManager.clearActiveUpload();
    }
  }
}
